import React from 'react';
import { Redirect } from '@americanexpress/one-app/router';
import ModuleRoute from '@americanexpress/one-app/holocron-module-route';
const childRoutes = () => [/*#__PURE__*/React.createElement(Redirect, {
  key: "/",
  from: "/",
  to: "/start"
}), /*#__PURE__*/React.createElement(ModuleRoute, {
  key: "/start",
  path: "/start",
  moduleName: "invoice-management-start"
})];
export default childRoutes;